export enum ComfortTypeEnum {    
    'Default' = 0,
    'Standard' = 1,
    'Comfort' = 2,
    'Threshold' = 3,
}